var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 26.5L0.695305 26.1876C0.596731 26.5203 0.66097 26.8801 0.868614 27.1581C1.07626 27.4362 1.40295 27.6 1.75 27.6V26.5ZM24.25 26.5V27.6C24.597 27.6 24.9237 27.4362 25.1314 27.1581C25.339 26.8801 25.4033 26.5203 25.3047 26.1876L24.25 26.5ZM18.15 7.75C18.15 10.5943 15.8443 12.9 13 12.9V15.1C17.0593 15.1 20.35 11.8093 20.35 7.75H18.15ZM13 12.9C10.1557 12.9 7.85 10.5943 7.85 7.75H5.65C5.65 11.8093 8.94071 15.1 13 15.1V12.9ZM7.85 7.75C7.85 4.90573 10.1557 2.6 13 2.6V0.4C8.94071 0.4 5.65 3.69071 5.65 7.75H7.85ZM13 2.6C15.8443 2.6 18.15 4.90573 18.15 7.75H20.35C20.35 3.69071 17.0593 0.4 13 0.4V2.6ZM2.8047 26.8124C4.18328 22.1588 8.25781 18.85 13 18.85V16.65C7.18415 16.65 2.32137 20.6985 0.695305 26.1876L2.8047 26.8124ZM13 18.85C17.7422 18.85 21.8167 22.1588 23.1953 26.8124L25.3047 26.1876C23.6786 20.6985 18.8159 16.65 13 16.65V18.85ZM1.75 27.6H24.25V25.4H1.75V27.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3cfd9e2055ad06b53e0923d2a1a4d42f.svg";
export { ForwardRef as ReactComponent };